import { AppError } from "config/errors";
import { globalFeatureFlagQuery } from "gql/queries/featureFlag";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchGlobalFlags = createAsyncThunk(
  "fetchGlobalFlags",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await globalFeatureFlagQuery();

      return data.globalFeatureFlags;
    } catch (err) {
      return rejectWithValue(AppError.from(err).toPlainObject());
    }
  }
);
